export default __webpack_public_path__ + "static/media/new-1.6fa35e34.png";